// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************

const _ModuleRegistry = require("../Ice/ModuleRegistry").Ice._ModuleRegistry;

module.exports.Ice = 
    (
        require("../Ice/Initialize"),
        require("../Ice/Communicator"),
        require("../Ice/HashMap"),
        require("../Ice/Object"),
        require("../Ice/Value"),
        require("../Ice/Long"),
        require("../Ice/Logger"),
        require("../Ice/ObjectPrx"),
        require("../Ice/BatchRequestQueue"),
        require("../Ice/Properties"),
        require("../Ice/IdentityUtil"),
        require("../Ice/ProcessLogger"),
        require("../Ice/Protocol"),
        require("../Ice/Identity"),
        require("../Ice/Exception"),
        require("../Ice/LocalException"),
        require("../Ice/BuiltinSequences"),
        require("../Ice/StreamHelpers"),
        require("../Ice/Promise"),
        require("../Ice/EndpointTypes"),
        require("../Ice/Locator"),
        require("../Ice/Router"),
        require("../Ice/Version"),
        require("../Ice/Buffer"),
        require("../Ice/ArrayUtil"),
        require("../Ice/UnknownSlicedValue"),
        require("../Ice/Process"),
        require("../Ice/MapUtil"),
        require("../Ice/ToStringMode")
    ).Ice;

module.exports.IceMX = require("../Ice/Metrics").IceMX;

module.exports.IceSSL = require("../Ice/EndpointInfo").IceSSL;



//////////////////
// WEBPACK FOOTER
// ./~/ice/src/Ice/Ice.js
// module id = 307
// module chunks = 0